import { Row, Col } from 'antd'

import './MultiVendorStyle.style.less'
import { calculateTotalOrderQty, isEmptyValue, parseJSON } from '@/utils/common'
import { flatMap, isEmpty } from 'lodash'

function MultiVendorStyle({ data }: any) {
  const findMasterPos = () => {
    const getOrders = isEmpty(data.orders) ? [data.order] : data.orders
    const result = getOrders.map((item) => {
      const findPropertyValue = (name) => {
        return item?.property_values?.find((val) => val.field == name)?.value
      }

      const findVailableQtyOrder = () => {
        const result = parseJSON(
          data?.inspectionPropertyValues?.find(
            (tmp) => tmp.field == 'all_sample_sizes'
          )?.value
        )
          ?.find((val) => val.order_id == item.id)
          ?.sub_items?.reduce((a, b) => {
            a = a + Number(b.actualQty)
            return a
          }, 0)
        return result
      }

      const findSampleSize = () => {
        const result = parseJSON(
          data?.inspectionPropertyValues?.find(
            (tmp) => tmp.field == 'all_sample_sizes'
          )?.value
        )
          ?.find((val) => val.order_id == item.id)
          ?.sub_items?.reduce((a, b) => {
            a = a + Number(b.sampleSize)
            return a
          }, 0)
        return result
      }

      return {
        masterPo: findPropertyValue('masterOrder'),
        ftpo: findPropertyValue('ftpo'),
        vendorStyle: findPropertyValue('styleId'),
        tjxStyle: findPropertyValue('tjxStyle'),
        orderQty: calculateTotalOrderQty(item),
        availableQty: findVailableQtyOrder(),
        sampleSize: findSampleSize(),
      }
    })
    return result || []
  }

  const renderData = flatMap(
    data?.generalInformation?.all_sample_sizes,
    'sub_items'
  )

  const isOldData = () => {
    if (renderData?.some((item) => item?.styleId)) {
      return false
    }
    return true
  }

  return (
    <div className="multi-vendor-table-container">
      <Row justify={'space-between'}>
        <Col span={7}>
          <p className="title">Vendor Style #</p>
        </Col>
        <Col span={4}>
          <p className="title">Master PO</p>
        </Col>
        <Col span={4}>
          <p className="title">TJX Style #</p>
        </Col>
        <Col flex={'auto'}>
          <p className="title">Order Qty</p>
        </Col>
        <Col flex={'auto'}>
          <p className="title">Available Qty</p>
        </Col>
        <Col flex={'auto'}>
          <p className="title">Sample Size</p>
        </Col>
      </Row>
      {!isOldData()
        ? renderData?.map((item, index) => {
            return (
              <Row key={index} className="multi-po-data-container">
                <Col span={7}>
                  <p className="value">{item?.styleId || '-'}</p>
                </Col>
                <Col span={4}>
                  <p className="value">{item?.masterOrder || '-'}</p>
                </Col>
                <Col span={4}>
                  <p className="value">{item?.tjxStyle || '-'}</p>
                </Col>
                <Col flex={'auto'}>
                  <p className="value">{item.quantity || '-'}</p>
                </Col>
                <Col flex={'auto'}>
                  <p className="value">{item.actualQty || '-'}</p>
                </Col>
                <Col flex={'auto'}>
                  <p className="value">{item.sampleSize || '-'}</p>
                </Col>
              </Row>
            )
          })
        : findMasterPos()?.map((item, index) => {
            return (
              <Row
                key={index}
                className="multi-po-data-container"
                justify={'space-between'}
              >
                <Col span={7}>
                  <p className="value">{item?.vendorStyle || '-'}</p>
                </Col>
                <Col span={4}>
                  <p className="value">{item?.masterPo || item?.ftpo || '-'}</p>
                </Col>
                <Col span={4}>
                  <p className="value">{item?.tjxStyle || '-'}</p>
                </Col>
                <Col flex={'auto'}>
                  <p className="value">{item.orderQty || '-'}</p>
                </Col>
                <Col flex={'auto'}>
                  <p className="value">{item.availableQty || '-'}</p>
                </Col>
                <Col flex={'auto'}>
                  <p className="value">{item.sampleSize || '-'}</p>
                </Col>
              </Row>
            )
          })}
    </div>
  )
}

export default MultiVendorStyle
